import { isAxiosError } from 'axios';

export const SAVE_FAILED_MESSAGE =
  'Could not save your availability. Please try again.';

/**
 * What to tell the person when saving their availability fails. A 400 means
 * the backend refused the content (for example two rules that overlap) and
 * wrote a sentence for the person who sent it, so that sentence is shown as
 * is. Anything else (a network failure, a server error, no permission) has
 * nothing a person can act on, so it stays the generic "try again" message
 * rather than leaking an internal error string.
 */
export const availabilitySaveErrorMessage = (error: unknown): string => {
  if (isAxiosError(error) && error.response?.status === 400) {
    const message = (error.response.data as { message?: unknown } | undefined)
      ?.message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }
  return SAVE_FAILED_MESSAGE;
};
